import React, { useContext } from 'react';
import { Stack, Typography } from '@mui/material';
import { ViewContext } from 'venuescanner-js/react/components/Inbox/context/ViewContext';
import { isOrganiser } from 'venuescanner-js/constants/user_type';
import { getTotal, isOfferBeforeStripeConnect } from '../../../helpers/quote';
import formatNumber from 'venuescanner-js/helpers/formatNumber';
import { EnquiryInfoItem } from '../EnquiryInfoItem';

export function PaymentInfo({ thread }) {
  const { activeCurrency } = useContext(ViewContext);
  const { cumulativeOffer } = thread;

  const total = getTotal(cumulativeOffer, activeCurrency.currency.code);
  const didHostAddVAT =
    !cumulativeOffer.vat_included && !cumulativeOffer.vat_exempt;

  // We have to deal with existing quotes in which payment_type does not exist
  // It should be deleted when all offers have a payment type,
  // once we migrate to Stripe Connect

  return (
    <>
      <EnquiryInfoItem title='Total' value={total} isCurrency bold />
      {isOrganiser(thread) &&
        !isOfferBeforeStripeConnect(cumulativeOffer) &&
        didHostAddVAT && (
          <Typography component='small' variant='caption'>
            Price includes VAT
          </Typography>
        )}
      {/* For existing quotes which had deposits, it could be removed once we migrate to Sripe Connect and no offers have deposits */}
      {!cumulativeOffer.payment_type &&
        cumulativeOffer.first_deposit_amount > 0 &&
        cumulativeOffer.first_deposit_amount !== parseFloat(total) && (
          <Stack
            direction='row'
            justifyContent='space-between'
            sx={{ py: 1, fontWeight: 700 }}>
            <Typography>Amount payable to confirm booking</Typography>
            <Typography>
              {activeCurrency.currency.symbol}
              {formatNumber(cumulativeOffer.first_deposit_amount)}
            </Typography>
          </Stack>
        )}
    </>
  );
}
